module.exports = __webpack_public_path__ + "static/media/40pic.5fbf4074.jpg";